const AUTH_COOKIE_NAME = "ubt";

function resolveCookieName(cname) {
  if (cname === AUTH_COOKIE_NAME) {
    return process.env.REACT_APP_AUTH_COOKIE_NAME || AUTH_COOKIE_NAME;
  }

  return cname;
}

function getCookieDomain() {
  return process.env.REACT_APP_DOMAIN
    ? `;domain=${process.env.REACT_APP_DOMAIN}`
    : "";
}

function getCookieSecurityAttributes() {
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    return ";SameSite=Lax;Secure";
  }

  return ";SameSite=Lax";
}

function buildCookie(cname, cvalue, expires) {
  return (
    cname +
    "=" +
    cvalue +
    ";" +
    expires +
    ";path=/" +
    getCookieDomain() +
    getCookieSecurityAttributes()
  );
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();

  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

  let expires = "expires=" + d.toUTCString();
  const cookieName = resolveCookieName(cname);

  document.cookie = buildCookie(cookieName, cvalue, expires);

  if (cname === AUTH_COOKIE_NAME && cookieName !== AUTH_COOKIE_NAME) {
    document.cookie = buildCookie(
      AUTH_COOKIE_NAME,
      "",
      "expires=Thu, 01 Jan 1970 00:00:00 GMT"
    );
  }
}

function getCookie(cname) {
  let name = resolveCookieName(cname) + "=";
  let ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

function checkCookie(cname) {
  let user = getCookie(cname);

  if (user !== "") {
    alert("Welcome again " + user);
  } else {
    user = prompt("Please enter your name:", "");
    if (user !== "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}

module.exports = {
  setCookie,
  getCookie,
  checkCookie,
};
